import { triggerCustomEvent } from "./EventTrigger";

export default class Tags
{
    protected root: Element;
    protected classes = {
        item: 'tags__item',
    }

    public constructor(node: Element)
    {
        this.root = node;

        this.appendEventListeners();
    }

    protected appendEventListeners()
    {
        this.root.querySelectorAll('.' + this.classes.item).forEach(item => {
            item.addEventListener('click', () => this.triggerSelectedEvent(
                item.getAttribute('data-key'),
                (item as HTMLElement).innerText
            ));
        });
    }

    private triggerSelectedEvent(key: string, title: string)
    {
        triggerCustomEvent(this.root, 'tags-item-selected', {
            detail: {key: key, title: title,}
        });
    }
}
